//removeIf(production)
const QrScanner = require('../../../../../external/qr-code/qr-scanner.min.js');
import ClaroluzEventDispatch from '../../../../../infra/services/claroluz-event-dispatch';
import ClaroluzEvents from '../../../../../infra/critical/claroluz-events';
import ClaroluzQr from '../../../../../infra/services/claroluz-qr';
import ClaroluzTypeChange from '../uploader/claroluz-type-change';
//endRemoveIf(production)

class ClaroluzQrWorker {
    private scanner: any;
    private containerSelector: string;

    constructor(mainContainer: string, alternativeMode: string) {
        this.containerSelector = '.claroluz-qr';
    
        if (typeof QrScanner === 'undefined') {
            new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'desktop-version');
            document.querySelector('.steps-btn-container')?.classList.add('display-none');
            this.goToAlternativeMode();
            return;
        }

        this.scanner = new ClaroluzQr(QrScanner, '.claroluz-qr-scanner');
        

        this.checkCamera().then((hasCamera: boolean) => {
            if (hasCamera) {
                this.clickEvent();
                this.successEvent();
                this.errorEvent();
                this.resetEvent();
            }
        });
    }

    private async checkCamera(): Promise<boolean> {
        let hasCamera = await this.scanner.hasCamera();

        if (!hasCamera) {            
            new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'no-camera');
            document.querySelector('.steps-btn-container')?.classList.add('display-none');
            this.stop();            
            return false;
        }

        return true;
    }

    private clickEvent() {
        document.addEventListener('claroluz_send_qr', () => {
            new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'click');
            this.start();
        });
    }

    private successEvent() {
        document.addEventListener('claroluz_bill', (event: any) => {
            new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'qr-code-success');
            new ClaroluzEventDispatch('claroluz_submit', {type: 'qr-code', data: event.detail});
        });
    }

    private errorEvent() {
        document.addEventListener('claroluz_error', (event: any) => {
            if (event.detail.type === 'qr-code') {
                new ClaroluzEvents(appProperties(), 'uploader', 'qr-code', 'ERROR_QR_CODE');
                this.stop();
            }
        });
    }

    private resetEvent() {
        document.addEventListener('claroluz_reset_qr', () => {
            this.scanner.reset();
        });
    }

    private start() {
        document.querySelector(this.containerSelector)?.classList.add('scan');

        this.scanner.start();
    }

    private stop() {
        this.goToAlternativeMode();
        this.scanner.destroy();
    }

    private goToAlternativeMode() {
        new ClaroluzTypeChange('type-pdf', true);
    }
}

//removeIf(production)
export default ClaroluzQrWorker;

function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error('Function not implemented.');
}
//endRemoveIf(production)